import { withRedirectToLogin } from '../../hocs/withRedirectToLogin';
import { Layout } from 'antd';

import { FC, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { MeProfile } from '../../shared/MySrcm';
import { UserRole } from '../../shared/VolunteerApplicationServiceTypes';
import { useBatchId } from '../../hooks/useBatchId';
import { BATCH_HOME, FUNCTIONARY_HOME, ROOT } from '../../shared/Routes';
import { AppHeader } from './AppHeader';
import { useAuth } from '../../hooks/useAuth';
import { FUNCTIONARY_ROLES, hasPrivilege } from '../../shared/Utils';
import { PrivilegeCodes } from '../../shared/RoleConstants';
import useUserSession from '../../hooks/useUserSession';

const { Content } = Layout;

interface LayoutProps {
	logout?: () => Promise<void>;
	firebaseId?: string | null;
	srcmId?: string;
	mySrcmProfile?: MeProfile | null;
	loading?: boolean;
	selectedRole?: UserRole | null;
}

export const ApplicantLayout: FC<LayoutProps> = ({
	firebaseId,
	srcmId,
	mySrcmProfile,
	loading,
	selectedRole,
	logout,
}: LayoutProps) => {
	const { pathname } = useLocation();
	const { navigateToRoute } = useBatchId();
	const { isLoggedIn } = useAuth();
	const { loggedInUserPrivileges } = useUserSession();

	const showCreateBatch = hasPrivilege(
		PrivilegeCodes.CREATE_BATCH,
		loggedInUserPrivileges
	);

	const showUpdateBatch = hasPrivilege(
		PrivilegeCodes.UPDATE_BATCH,
		loggedInUserPrivileges
	);

	const showEligibleCandidates = hasPrivilege(
		PrivilegeCodes.GET_ELIGIBLE_CANDIDATES_FOR_NEXT_BATCH,
		loggedInUserPrivileges
	);

	const showBatchesPage =
		showCreateBatch || showUpdateBatch || showEligibleCandidates;

	useEffect(() => {
		if (!pathname.includes('hfnauth') && !(isLoggedIn && isLoggedIn())) {
			navigateToRoute(ROOT);
		}
	}, [isLoggedIn, navigateToRoute, pathname]);

	useEffect(() => {
		if (selectedRole && FUNCTIONARY_ROLES.includes(selectedRole)) {
			navigateToRoute(showBatchesPage ? BATCH_HOME : FUNCTIONARY_HOME);
		}
	}, [selectedRole, showBatchesPage, navigateToRoute]);

	const isApplicantRole = selectedRole === UserRole.APPLICANT;

	return (
		<>
			<AppHeader logout={logout} mySrcmProfile={mySrcmProfile} />
			<div className="flex justify-center bg-bground-blue">
				<div className="border p-[8px] w-full">
					<Layout className="mainlayout rounded-md p-[8px] bg-bground-blue">
						<Content className="bg-bground-blue">
							{!loading && isApplicantRole && (
								<Outlet context={{ srcmId, firebaseId, selectedRole }} />
							)}
						</Content>
					</Layout>
				</div>
			</div>
		</>
	);
};

export default withRedirectToLogin<object>(ApplicantLayout);
